import axios from 'axios';
import { API_KEY, API_S3_URL, API_URL, CLIENT_CODE, clientUserId } from '../config/veriables';
import md5 from 'md5';
import { FileProcessingResult } from '../types/FileProcessingResult';
import { InputData } from '../components/InputForm/types';

export const toBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result as string);
  reader.onerror = reject;
});

const deleteImage = async (result: string) => {
  await axios.delete(`${API_S3_URL}/delete`, {
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(result),
  })
}

const getProcessingResultRequest = async (clientHandleId: string): Promise<FileProcessingResult> => {
  const { data } = await axios.get(`${API_URL}/receive`,  { headers: { 'X-Api-Key': API_KEY } });

  if (!Array.isArray(data)) {
    throw new Error();
  }

  const result = (data as FileProcessingResult[]).find(({ capture }) => capture['client-handle-id'] === clientHandleId);

  if (!result) {
    return await new Promise((resolve, reject) => {
      setTimeout(() => {
        getProcessingResultRequest(clientHandleId).then(resolve).catch(reject);
      }, 2000);
    });
  }

  return result;
};

export const sendFilesRequest = async ({ productName, purchaseValidation, brandName, gtin }: InputData, files: File[]): Promise<any> => {
  const clientHandleId = md5('' + Math.random());

  const imagesLinks = await Promise.all(files.map((file, index) => {
    const parts = file.name.split('.');
    const fileName = `${clientHandleId}_${index + 1}.${parts[parts.length - 1]}`

    return toBase64(file)
      .then((blob) => (
        axios.put(`${API_S3_URL}/upload/${fileName}`, file, {
          headers: {
            'Content-Type': parts[parts.length - 1] === 'pdf' ? 'application/pdf' : 'image/jpeg',
          },
        })
      ))
      .then(() => `https://s3.amazonaws.com/ourcart.platform.snapshots.staging/demo/${fileName}`);
  }));

  const { data } = await axios.post(`${API_URL}/send`, {
    "client-code": CLIENT_CODE,
    "client-handle-id": clientHandleId,
    "client-user-id": clientUserId,
    "country": "US",
    "transcription-method": "AUTOMATIC",
    "snapshots": imagesLinks.map((url) => ({ url })),
    "products-of-interest": [
      purchaseValidation && {
        brand: brandName,
        gtin: gtin ? gtin : undefined,
        "title": productName,
      }
    ].filter(Boolean)
  },{ headers: { 'X-Api-Key': API_KEY } });

  if (data !== 'OK') {
    throw new Error();
  }

  return await getProcessingResultRequest(clientHandleId);
};

